
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "jst/outcomes/_criterionHeader";
import "jst/outcomes/_criterion";
import "i18n!outcomes.outcome_form";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'outcomes/outcomeForm';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function";

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <div class=\"pull-right\">\n      <a href=\"#\" class=\"rte_switch_views_link\">\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.outcome_form")
  },data:data},helper ? helper.call(depth0, "HTML Editor", options) : helperMissing.call(depth0, "t", "HTML Editor", options)))
    + "\n      </a>\n      <a href=\"#\" class=\"rte_switch_views_link\" style=\"display:none;\">\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.outcome_form")
  },data:data},helper ? helper.call(depth0, "Rich Content Editor", options) : helperMissing.call(depth0, "t", "Rich Content Editor", options)))
    + "\n      </a>\n    </div>\n    <div style=\"clear:both;\"></div>\n  ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <label>\n      <div style=\"display: flex\">\n        <div id='criterion_rating_label' style=\"margin-top: 0.65rem\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.outcome_form")
  },data:data},helper ? helper.call(depth0, "criterion", "Criterion ratings", options) : helperMissing.call(depth0, "t", "criterion", "Criterion ratings", options)))
    + ":</div>\n        <div id=\"react-info-link\" />\n      </div>\n    </label>\n    <table class=\"criterion\" aria-labelledby='criterion_rating_label'>\n      <thead>\n        <tr>\n          ";
  stack1 = (helper = helpers.eachWithIndex || (depth0 && depth0.eachWithIndex),options={hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.ratings), options) : helperMissing.call(depth0, "eachWithIndex", (depth0 && depth0.ratings), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          <th class=\"total\" aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "total_points_44d76792", "Total Points", options) : helperMissing.call(depth0, "t", "total_points_44d76792", "Total Points", options)))
    + "'>\n            <h5 class=\"total\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "total_points_44d76792", "Total Points", options) : helperMissing.call(depth0, "t", "total_points_44d76792", "Total Points", options)))
    + "</h5>\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr>\n          ";
  stack1 = (helper = helpers.eachWithIndex || (depth0 && depth0.eachWithIndex),options={hash:{},inverse:self.noop,fn:self.program(6, program6, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.ratings), options) : helperMissing.call(depth0, "eachWithIndex", (depth0 && depth0.ratings), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        <td class=\"total\">\n          <div class=\"points_possible\">\n            ";
  stack1 = (helper = helpers.n || (depth0 && depth0.n),options={hash:{
    'precision': (2),
    'strip_insignificant_zeros': (true)
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.points_possible), options) : helperMissing.call(depth0, "n", (depth0 && depth0.points_possible), options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'n_points_possible_precision_2_st': (stack1),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "n_points_possible_precision_2_st_points_bc3748df", "%{n_points_possible_precision_2_st} Points", options) : helperMissing.call(depth0, "t", "n_points_possible_precision_2_st_points_bc3748df", "%{n_points_possible_precision_2_st} Points", options)))
    + "\n          </div>\n        </td>\n        </tr>\n      </tbody>\n    </table>\n    <div>\n      <label for=\"mastery_points\" style=\"display: inline\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.outcome_form")
  },data:data},helper ? helper.call(depth0, "mastery", "Mastery at", options) : helperMissing.call(depth0, "t", "mastery", "Mastery at", options)))
    + ":</label>\n      <input type=\"text\" name=\"mastery_points\" style=\"width: 20px;\" class=\"mastery_points\" id=\"mastery_points\" value=\""
    + escapeExpression((helper = helpers.n || (depth0 && depth0.n),options={hash:{
    'precision': (2),
    'strip_insignificant_zeros': (true)
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.mastery_points), options) : helperMissing.call(depth0, "n", (depth0 && depth0.mastery_points), options)))
    + "\">\n    </div>\n    <div>\n      <label for=\"calculation_method\" style=\"display: inline\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.outcome_form")
  },data:data},helper ? helper.call(depth0, "calculation_method", "Calculation Method", options) : helperMissing.call(depth0, "t", "calculation_method", "Calculation Method", options)))
    + ":</label>\n      <select name=\"calculation_method\" class=\"calculation_method\" id=\"calculation_method\" data-calculation-method=\"";
  if (helper = helpers.calculation_method) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.calculation_method); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" value=\"";
  if (helper = helpers.calculation_method) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.calculation_method); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n        ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.calculationMethods), {hash:{},inverse:self.noop,fn:self.programWithDepth(8, program8, data, depth0),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </select>\n    </div>\n    <div class=\"content-box\">\n      <div class=\"grid-row\">\n        <!-- Hook for OutcomeCalculationMethodFormView -->\n        <div class=\"col-xs-12 outcome-calculation-method-form\"></div>\n      </div>\n    </div>\n  ";
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n            ";
  stack1 = self.invokePartial(partials['outcomes/criterionHeader'], 'outcomes/criterionHeader', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  return buffer;
  }

function program6(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n            ";
  stack1 = self.invokePartial(partials['outcomes/criterion'], 'outcomes/criterion', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  return buffer;
  }

function program8(depth0,data,depth1) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <option value=\""
    + escapeExpression(((stack1 = (data == null || data === false ? data : data.key)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" "
    + escapeExpression((helper = helpers.selectedIf || (depth1 && depth1.selectedIf),options={hash:{},data:data},helper ? helper.call(depth0, (data == null || data === false ? data : data.key), (depth1 && depth1.calculation_method), options) : helperMissing.call(depth0, "selectedIf", (data == null || data === false ? data : data.key), (depth1 && depth1.calculation_method), options)))
    + ">\n            ";
  if (helper = helpers.friendlyCalculationMethod) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.friendlyCalculationMethod); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n          </option>\n        ";
  return buffer;
  }

  buffer += "<form action=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"learning_outcome\" method=\"post\">\n\n  <label class=\"span3\" for=\"title\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.outcome_form")
  },data:data},helper ? helper.call(depth0, "title", "Name this outcome", options) : helperMissing.call(depth0, "t", "title", "Name this outcome", options)))
    + ":</label>\n  <input class=\"outcome_title span3\" name=\"title\" id=title size=\"50\" type=\"text\" value=\"";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" placeholder=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "new_outcome_7fba8c7d", "New Outcome", options) : helperMissing.call(depth0, "t", "new_outcome_7fba8c7d", "New Outcome", options)))
    + "\">\n\n  <label class=\"span3\" for=\"display_name\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.outcome_form")
  },data:data},helper ? helper.call(depth0, "display_name", "Friendly name (optional)", options) : helperMissing.call(depth0, "t", "display_name", "Friendly name (optional)", options)))
    + ":</label>\n  <input class=\"outcome_display_name span3\" name=\"display_name\" id=display_name size=\"50\" type=\"text\" value=\"";
  if (helper = helpers.display_name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.display_name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n\n  <label for=\"description\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.outcome_form")
  },data:data},helper ? helper.call(depth0, "description", "Describe this outcome", options) : helperMissing.call(depth0, "t", "description", "Describe this outcome", options)))
    + ":</label>\n\n  ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.use_rce_enhancements), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  <textarea cols=\"40\" name=\"description\" id=description rows=\"20\" style=\"display: none; width: 100%; height: 150px;\">";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</textarea>\n\n  ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.hideMasteryScale), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  <div class=\"align-right\">\n    <button type=\"button\" class=\"btn cancel_button\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.outcome_form")
  },data:data},helper ? helper.call(depth0, "#buttons.cancel", "Cancel", options) : helperMissing.call(depth0, "t", "#buttons.cancel", "Cancel", options)))
    + "</button>\n    <button type=\"submit\" class=\"btn btn-primary submit_button\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.outcome_form")
  },data:data},helper ? helper.call(depth0, "#buttons.save", "Save", options) : helperMissing.call(depth0, "t", "#buttons.save", "Save", options)))
    + "</button>\n  </div>\n</form>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  